<template>
    <div>

        <!-- Header -->
        <div class="py-3 mb-3 border-bottom">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-sm-6 d-flex">
                        <h5 class="m-0 p-0 align-self-center">
                            Professores
                        </h5>
                    </div>
                    <div class="col-12 col-sm-6 text-left text-sm-right d-flex justify-content-end">
                        <!-- Create -->
                        <b-button type="button" class="" @click="createTeacher">
                            <i class="fas fa-plus mr-1"></i>
                            Adicionar Professor
                        </b-button>
                    </div>
                </div>
            </div>
        </div>

        <div id="teachers" class="container">
            <b-overlay :show="loading" rounded="sm">
                <b-card v-for="teacher in teachers" :key="teacher.id" class="mb-3 font-weight-bold-500">

                    <div class="form-row">

                        <div class="col-12 col-sm-8">
                            <div v-if="!! teacher.permissions.personal">
                                <i class="fas fa-shield-alt mr-1"></i>

                                <span>
                                    Administrador
                                </span>
                            </div>
                            <div>
                                <i class="fas fa-user-graduate mr-1 mb-1"></i> {{ teacher.name }}
                            </div>
                            <div>
                                <i class="fas fa-envelope mr-1 mb-1"></i> {{ teacher.email }}
                            </div>
                            <div>
                                 <span class="mr-1">
                                     <i class="fas fa-money-bill mr-1"></i>
                                     <b class="text-primary">{{ teacher.permissions.price | currency('R$ ', 2, { decimalSeparator: ',' }) }}</b> por redação corrigida
                                 </span>

                                <a class="mr-1" href="javascript:void(1);" @click="editPrice(teacher)" v-b-tooltip.hover title="Editar Valor Unitário">
                                    <i class="fas fa-edit"></i>
                                </a>

                            </div>

                            <div v-if="revisorTeacher">
                                <span class="mr-1">
                                    <i class="fas fa-money-bill mr-1"></i>
                                    <b class="text-primary">{{ teacher.permissions.review_price | currency('R$ ', 2, { decimalSeparator: ',' }) }}</b> por revisão finalizada
                                </span>

                               <a class="mr-1" href="javascript:void(1);" @click="editReviewPrice(teacher)" v-b-tooltip.hover title="Editar Valor Unitário">
                                   <i class="fas fa-edit"></i>
                               </a>

                            </div>
                        </div>

                    </div>

                    <div class="mt-3 pt-3 border-top" v-if="! teacher.permissions.personal">

                        <div class="row">
                            <div v-for="permission in permissions" :key="permission.name" class="col-12 col-sm-6">
                                <i
                                    v-if="teacher.permissions[permission.name]"
                                    class="fas fa-check text-success mr-1">
                                </i>
                                <i
                                    v-else class="fas fa-times text-danger mr-2">
                                </i>

                                {{ permission.description }}
                            </div>
                        </div>

                    </div>

                    <template #footer v-if="! teacher.permissions.personal">

                        <button type="button" class="btn btn-sm btn-outline-danger float-left float-sm-right" @click="destroy(teacher.id)">
                            Remover
                        </button>

                        <button type="button" class="mr-2 btn btn-sm btn-outline-primary float-left float-sm-right" @click="updatePermissionsModal(teacher)">
                            Alterar Permissões
                        </button>

                    </template>

                </b-card>

            </b-overlay>

            <b-modal
                id="editPermission"
                title="Editar Permissões"
                size="lg"
                hide-footer>

                <b-overlay :show="loadingPermission" rounded="sm">

                    <div class="row mb-3">
                        <div v-for="permission in permissions" :key="permission.name" class="col-12 col-sm-6">

                            <b-form-checkbox
                                v-model="form[permission.name]"
                                switch>

                                {{ permission.description }}

                            </b-form-checkbox>

                        </div>
                    </div>

                    <b-button type="button" variant="primary" @click="updatePermission">
                        Atualizar Permissões
                    </b-button>

                </b-overlay>
            </b-modal>

            <!-- Update Price -->
            <edit-price></edit-price>

            <edit-review-price></edit-review-price>
            <!--add Teacher Modal-->
            <create @created="load"></create>
        </div>
    </div>
</template>

<script>
import EditPrice from "./EditPrice";
import Create from "./Create.vue";
import EditReviewPrice from './EditReviewPrice.vue';

export default {
    props: ['query', 'revisorTeacher'],
    components: {
        EditPrice,
        Create,
        EditReviewPrice,
    },
    data() {
        return {
            loading: false,
            loadingPermission: false,
            teachers: [],
            teacherPermissionId: null,
            form: {},
            permissions: [
                {
                    name: 'permission_groups',
                    description: 'Poderá gerenciar as turmas'
                },
                {
                    name: 'permission_students',
                    description: 'Poderá gerenciar os alunos'
                },
                {
                    name: 'permission_themes',
                    description: 'Poderá gerenciar os temas'
                },
                {
                    name: 'permission_tasks',
                    description: 'Poderá gerenciar as atividades'
                },
                {
                    name: 'permission_pre_comments',
                    description: 'Poderá gerenciar o banco de comentários'
                },
                {
                    name: 'permission_essays',
                    description: 'Poderá gerenciar as redações'
                },
                {
                    name: 'permission_essays_send',
                    description: 'Poderá enviar redações'
                },
                {
                    name: 'permission_essays_all',
                    description: 'Poderá ver todas as redações'
                },
                {
                    name: 'permission_essays_teacher',
                    description: 'Poderá selecionar os corretores'
                },
                {
                    name: 'permission_essays_destroy',
                    description: 'Poderá excluir redações'
                },
                {
                    name: 'permission_reports',
                    description: 'Poderá ver os relatórios dos alunos'
                },
                {
                    name: 'permission_reports_teacher',
                    description: 'Poderá ver os relatórios dos professores'
                },
                {
                    name: 'permission_courses',
                    description: 'Poderá ver gerenciar o módulo de cursos'
                },
            ]
        }
    },
    created() {

        this.load()

        this.permissions.forEach((element) => {
            this.form[element.name] = false;
        })

    },
    methods: {

        load() {
            this.loading = true;
            axios.get('/teacher/teachers')
                .then((result) => {
                    const response = result.data.data

                    this.teachers = response.teachers
                })
                .finally(() => this.loading = false)
        },

        destroy(id) {
            if (confirm('Deseja realmente desvincular esse professor da sua escola ?')) {
                this.loading = true;
                axios.delete('/teacher/teachers/' + id)
                    .then((result) => {
                        // Success
                        this.$toast.success('O professor foi desvinculado com sucesso');

                        // Load
                        this.load();
                    })
                    .finally(() => this.loading = false)
            }
        },

         updatePermissionsModal(teacher) {

            this.teacherPermissionId = teacher.id;

            this.form = {};

            this.permissions.forEach((element) => {
                this.form[element.name] = !! teacher.permissions[element.name];
            })

            this.$bvModal.show('editPermission');

            this.$forceUpdate();

        },

        updatePermission() {
            this.loadingPermission = true;

            axios.put('/teacher/teachers/' + this.teacherPermissionId + '/permissions', {
                permissions: this.form
            })
                .then((result) => {

                    // Success
                    this.$toast.success('As permissões foram atualizadas com sucesso');

                    // Load
                    this.load();

                    // Hide
                    this.$bvModal.hide('editPermission');

                    this.$forceUpdate();

                })
                .finally(() => this.loadingPermission = false)

        },

        editPrice(teacher) {
            this.$root.$emit('editPrice', teacher);
        },

        editReviewPrice(teacher) {
            this.$root.$emit('editReviewPrice', teacher);
        },

        createTeacher() {
            this.$root.$emit('createTeacher')
        },

    }
}
</script>

<style scoped>

</style>
